import React from 'react';
import type { Store } from 'redux';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { HorizontalPlansNav } from './ui/index.tsx';

type Props = {
	store?: Store<State>;
};

const LazyHorizontalPlansNav = lazyForPaint<typeof HorizontalPlansNav>(
	() =>
		import(/* webpackChunkName: "async-software-horizontal-nav-plans" */ './ui').then(
			({ HorizontalPlansNav }) => HorizontalPlansNav,
		),
	{ entryFsSsrOverride: 'exclude' },
);

export const AsyncHorizontalNavPlans = ({ store }: Props) => (
	<Placeholder name="horizontal-software-plans-nav" fallback={null}>
		<LazyHorizontalPlansNav store={store} />
	</Placeholder>
);
